const companiesRoute = {
	name: 'companies',
	path: 'companies',
	meta: {
		title: 'Compañías',
	},
	component: () => import('@/pages/configuration/companies'),
};

export default companiesRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/companies/index.js